interface IReaderCountProps {
    count: number;
}

const ReaderCount = ({ count = 0 }: IReaderCountProps): JSX.Element => {
    return (
        <span className="readerCount" data-testid="reader-count">
            {count} reading now
        </span>
    );
};

export const SRSReaderCount = ({ count }: IReaderCountProps): JSX.Element => {
    return <span className="readerCount">{count} have read</span>;
};

export default ReaderCount;
